import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'

import Select from '../Select/Select'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class BranchSelect extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    showInternalServices: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    allOption: PropTypes.bool,
    className: PropTypes.string,
    userBranch: PropTypes.string,
    required: PropTypes.bool,
    withoutRegions: PropTypes.bool,
    disabled: PropTypes.bool,
    attrs: PropTypes.object,
    excludeInactive: PropTypes.bool
  }

  state = {
    options: [],
    error: null,
    loading: false,
    missionsSelectBranchs: []
  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
    .then(resp => this.setState({missionsSelectBranchs: resp.data.split(",")}))
  }

  componentDidMount() {
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }
    this.getParameter(params).finally(() => this.fetchData())
    
  }

  fetchData = async () => {
    const { user, excludeInactive } = this.props

    if (user) {
      this.setState({ loading: true })

      try {
        const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
        const { data } = await new Api(user.dsToken).post(endpoint)

        this.onFetchSuccess(data)
      } catch (error) {
        this.onFetchError(error)
      }
    }
  }

  onFetchSuccess(companies) {
    const { withoutRegions } = this.props
    const regionCompanies = []
    let companyOptions = []

    if (withoutRegions) {
      companyOptions = [...companies]
        .sort((a, b) => (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0))
        .map(branch => ({
          value: branch.id,
          label: `${branch.id} - ${branch.name} `,
        }))
    } else {
      // eslint-disable-next-line array-callback-return
      companies.map((company) => {
        if (regionCompanies[company.idRegion] === undefined) {
          regionCompanies[company.idRegion] = []
          regionCompanies[company.idRegion].idRegion = company.idRegion
          regionCompanies[company.idRegion].dsRegion = company.dsRegion
          regionCompanies[company.idRegion].branches = []
        }
        regionCompanies[company.idRegion].branches.push(company)
      })

      regionCompanies.sort((a, b) => (a.dsRegion > b.dsRegion ? 1 : -1))

      // eslint-disable-next-line array-callback-return
      regionCompanies.map((region) => {
        companyOptions.push({
          value: region.idRegion,
          label: region.dsRegion,
          visible: true,
        })

        // eslint-disable-next-line array-callback-return
        region.branches.map((branch) => {
          companyOptions.push({
            value: branch.id,
            label: `${branch.id} - ${branch.name} `,
            isBranch: true,
            idRegion: branch.idRegion,
            visible: true,
          })

          return branch
        })

        return region
      })
    }

    this.setState({
      options: companyOptions,
      loading: false,
      error: null,
    })
  }

  onFetchError = (error) => {
    this.setState({
      error,
      loading: false,
      options: [],
    })
  }

  handleChange = (value) => {
    const { onChange, name } = this.props
    const event = { target: { name, value } }
    onChange && onChange(event)
  }

  render() {
    const { label, value, required, translate, placeholder, disabled, attrs } = this.props
    const { options, loading } = this.state

    const placeholderLabel = loading ? translate('loading') : placeholder

    return (
      <Select
        label={label}
        placeholder={placeholderLabel}
        value={options.length ? (options.find(option => option.value === value) || value) : null}
        options={options}
        onChange={this.handleChange}
        required={required}
        disabled={disabled && ( !this.state.missionsSelectBranchs.includes(this.props.user.title) ) ||  !(this.props.userBranch === "999" || this.props.userBranch === undefined)}
        {...attrs}
      />
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

/*
 * Connects component to I18next
 */
const BranchSelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(BranchSelect)

/*
 * Exports component connected to redux
 */
export default connect(mapStateToProps)(BranchSelectTranslated)

/*
 * Exports component only
 */
export { BranchSelect }
